
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class AddSuccess extends Vue {
  addCommodity () {
    this.$router.replace('/addCommodity')
  }
}
